// third-party
import { createSlice } from "@reduxjs/toolkit";

// types
import { dispatch } from "../index";
import { UpdateLicenseStateProps } from "types/license-update";

// ----------------------------------------------------------------------

const initialState: UpdateLicenseStateProps = {
  order: "",
  step: 0,
};

// ==============================|| SLICE - CART ||============================== //

const slice = createSlice({
  name: "license",
  initialState,
  reducers: {
    // ADD ORDER
    licensePlace: (state, action) => {
      state.order = action.payload.orderData;
      return state;
    },
    // UPDATE ORDER
    updateLicenseOrderData: (state, action) => {
      state.order = action.payload.orderData;
      return state;
    },
    // UPDATE ORDER ITEM
    updateLicenseOrderItemData: (state, action) => {
      state.order = action.payload.order_item;
      return state;
    },
    // REMOVE ORDER
    licenseOrderRemove: () => initialState,
    // GET ORDER
    userOrder: (state) => {
      return state;
    },
    // SET STEP
    setLicenseStepSuccess(state, action) {
      state.step = action.payload;
    },

    // SET NEXT STEP
    setLicenseNextStepSuccess(state, action) {
      state.step += 1;
    },

    // SET BACK STEP
    setLicenseBackStepSuccess(state, action) {
      state.step -= 1;
    },
  },
});

// Reducer
export default slice.reducer;

export const {
  licensePlace,
  updateLicenseOrderData,
  updateLicenseOrderItemData,
  licenseOrderRemove,
  userOrder,
} = slice.actions;

export function setLicenseStep(step: number) {
  return () => {
    dispatch(slice.actions.setLicenseStepSuccess(step));
  };
}

export function setLicenseNextStep() {
  return () => {
    dispatch(slice.actions.setLicenseNextStepSuccess({}));
  };
}

export function setLicenseBackStep() {
  return () => {
    dispatch(slice.actions.setLicenseBackStepSuccess({}));
  };
}
